// Mock data for E-E-A-T診断ツール Landing Page

export const heroContent = {
  mainCopy: "E-E-A-T＋独自性を\n数値で可視化",
  subCopy: "記事を5観点・5段階でスコア化。\n改善ポイントを具体的にレポートします。",
  ctaText: "まずは無料で診断してみる",
  ctaSubText: "月2記事まで無料・初期費用なし",
  disclaimer: "※本ツールは検索順位を保証するものではありません"
};

export const challenges = [
  {
    id: 1,
    icon: "FileStack",
    title: "生成AI記事の量産で差別化が難しい",
    description: "競合も同様の記事を量産する中、どこで差をつけるか判断に迷う"
  },
  {
    id: 2,
    icon: "UserX",
    title: "リライト対象の判断が属人的",
    description: "担当者の経験や感覚に頼り、一貫した基準がない"
  },
  {
    id: 3,
    icon: "TrendingDown",
    title: "改善方法が分からず順位が伸びない",
    description: "何を直せばいいか分からず、闇雲な修正で工数だけが増える"
  },
  {
    id: 4,
    icon: "Clock",
    title: "人手レビューの工数が重い",
    description: "1記事ごとの確認作業に時間がかかり、スケールしない"
  }
];

export const solutions = [
  {
    id: 1,
    icon: "BarChart3",
    title: "5段階スコアで客観的に評価",
    description: "E-E-A-T＋独自性を数値化。主観に頼らず、誰が見ても同じ基準で判断できます。"
  },
  {
    id: 2,
    icon: "FileText",
    title: "改善ポイントを具体的に提示",
    description: "「何を」「どう」直すべきか、レポートで明確に指示。外注先への指示書としても活用可能。"
  },
  {
    id: 3,
    icon: "Link",
    title: "URL・PDF共有だけで診断完了",
    description: "診断したい記事URLまたはPDFを共有するだけ。面倒な設定や連携は不要です。"
  },
  {
    id: 4,
    icon: "Brain",
    title: "Google品質評価ガイドライン準拠",
    description: "Googleの品質評価ガイドラインを学習したAIが評価。一定の相関性を検証済み。"
  }
];

export const comparisonData = {
  headers: ["評価項目", "一般的な\nSEOスコアツール", "AI文章\nチェックツール", "人手による\n記事レビュー", "E-E-A-Tチェッカー\n（本サービス）"],
  rows: [
    {
      item: "E-E-A-T評価",
      values: ["△ 一部のみ", "× 非対応", "○ 可能", "◎ 5軸で詳細評価"]
    },
    {
      item: "独自性評価",
      values: ["× 非対応", "△ コピー検出のみ", "○ 可能", "◎ 独自性スコア化"]
    },
    {
      item: "改善指示の具体性",
      values: ["△ 抽象的", "△ 文法中心", "○ 詳細だが属人的", "◎ 具体的・再現性高"]
    },
    {
      item: "属人性",
      values: ["○ 低い", "○ 低い", "× 高い", "◎ 低い"]
    },
    {
      item: "工数",
      values: ["◎ 低い", "◎ 低い", "× 高い", "◎ 低い"]
    },
    {
      item: "費用",
      values: ["△ 月額制が多い", "○ 比較的安価", "× 高コスト", "◎ 月2記事無料"]
    },
    {
      item: "SEOディレクター向け",
      values: ["○ 対応", "△ 部分的", "○ 対応", "◎ 最適化"]
    }
  ]
};

export const trustContent = {
  title: "特徴",
  subtitle: "ネットワークを活用し開発。\n改善に必要な人材のご紹介も可能",
  points: [
    {
      icon: "Users",
      title: "3,000名以上のライター・監修者ネットワーク",
      description: "ライターマッチングサービス「ミライトマッチ」を運営。多様な専門分野のライターや監修者と連携しています。",
      linkText: "ミライトマッチ",
      linkUrl: "https://miwrite-match.jp/"
    },
    {
      icon: "Building2",
      title: "600社以上が登録するミライトマッチが独自開発",
      description: "ミライトマッチでご支援した上場企業から大手マーケティング会社、スタートアップ企業様からの声を基に開発。"
    },
    {
      icon: "BookOpen",
      title: "Google品質評価ガイドラインを学習",
      description: "Googleが公開する品質評価ガイドラインの内容を学習したAIが診断を実施します。"
    },
    {
      icon: "AlertCircle",
      title: "検索順位保証ではありません",
      description: "本ツールはコンテンツ品質の評価・改善を支援するものであり、検索順位の上昇を保証するものではありません。"
    }
  ]
};

export const testimonials = [
  {
    quote: "リライトの改善箇所が明確でわかりやすい",
    author: "ライター様",
    gender: "female"
  },
  {
    quote: "フィードバックの質が高く、ぜひ他の記事もお願いしたい",
    author: "事業会社様",
    gender: "male"
  },
  {
    quote: "大量の記事もすぐにレポート化してくれて本当に素晴らしいツールです・・・！",
    author: "事業会社様",
    gender: "female"
  },
  {
    quote: "頑張って書いてても上位表示されない記事をブラッシュアップするのに使えそう",
    author: "B to Bマーケティング会社様",
    gender: "male"
  }
];

export const pricingContent = {
  title: "料金プラン",
  subtitle: "初期費用・月額費用なしで始められます",
  plans: [
    {
      name: "無料プラン",
      price: "0",
      unit: "円/月",
      features: [
        "毎月2記事まで無料診断",
        "E-E-A-T＋独自性の5軸評価",
        "改善ポイントレポート",
        "翌月も継続利用可能"
      ],
      ctaText: "無料で始める",
      highlighted: false
    },
    {
      name: "追加診断",
      price: "1,000",
      unit: "円/記事（税抜）",
      features: [
        "無料枠を超えた追加診断",
        "同一品質のレポート提供",
        "必要な分だけ利用可能",
        "レポート品質の保証あり"
      ],
      ctaText: "お問い合わせ",
      highlighted: true
    }
  ],
  sampleReportUrl: "https://docs.google.com/document/d/117W_0N7fjZTDu6tJBW-lI018fRDDe8EK/edit#heading=h.3s98e2q9aypn"
};

export const usageSteps = [
  {
    step: 1,
    title: "お問い合わせ",
    description: "フォームから診断希望の旨をご連絡ください"
  },
  {
    step: 2,
    title: "URL・PDF共有",
    description: "診断したい記事のURLまたはPDFを共有いただきます"
  },
  {
    step: 3,
    title: "診断実施",
    description: "AIが記事を分析し、スコアリングを実施"
  },
  {
    step: 4,
    title: "レポート確認",
    description: "改善ポイントを含むレポートをお届け"
  }
];

export const ctaContent = {
  title: "まずは無料で試してみませんか？",
  subtitle: "月2記事まで無料で診断できます。\n記事品質の可視化を、今日から始めましょう。",
  primaryCta: "無料診断を申し込む",
  secondaryCta: "サンプルレポートを見る"
};

export const clientLogos = [
  { 
    name: "Digital Trends", 
    url: "/images/assets/287z4m7r-s-166x26-b19c443c-660a-4a50-b13c-419f2e755ddf.svg",
    width: 166,
    height: 26
  },
  { 
    name: "SMS", 
    url: "/images/assets/qqgrq40a-s-412x44-webp-b65ff089-91d4-42a0-a27f-36bc31b5dc7d.png",
    width: 150,
    height: 32
  },
  { 
    name: "Media Engine", 
    url: "/images/assets/qtlos8dp-s-591x228-webp-2ceddfd3-04d6-4896-bd01-4fe70c57f3bb.png",
    width: 150,
    height: 58
  },
  { 
    name: "あなぶき興産", 
    url: "/images/assets/5eg7arof-s-375x75-webp-04c69f69-cc7b-41b7-8492-589f95010d4e.png",
    width: 150,
    height: 30
  },
  { 
    name: "Miwrite Match", 
    url: "/images/assets/k4d4l4qc-216x42xhead-logo-png-pagespeed-ic-quP-CxTEC5.webp",
    width: 150,
    height: 29
  },
  { 
    name: "Basic", 
    url: "/images/assets/0dm9eqbh-s-1000x300-v-fs-webp-a6a84dd5-cee2-442e-8e8b-22ab603243f4.png",
    width: 120,
    height: 36
  }
];

export const targetAudience = [
  "不動産・金融・医療など専門性が高いWebメディア",
  "E-E-A-Tや独自性を重視するSEOディレクター",
  "記事品質の判断基準を統一したい編集責任者"
];

export const faqs = [
  {
    question: "診断にはどのくらい時間がかかりますか？",
    answer: "通常、URLをお送りいただいてから1〜2営業日以内にレポートをお届けします。"
  },
  {
    question: "どのような記事でも診断できますか？",
    answer: "公開されているWebページ、またはPDF化されていればどんな記事でも可能です。"
  },
  {
    question: "競合サイトの記事も診断できますか？",
    answer: "はい、公開されている記事であれば競合サイトの記事も診断可能です。自社記事との比較にご活用いただけます。"
  },
  {
    question: "レポートはどのような形式で届きますか？",
    answer: "PDFまたはGoogleドキュメント形式でお届けします。",
    hasSampleLink: true
  },
  {
    question: "無料枠は毎月リセットされますか？",
    answer: "はい、毎月2記事分の無料枠が付与されます。繰り越しはできませんので、月内にご利用ください。"
  }
];